import i18n from '@/i18n';
// SCADA design tokens — single source of truth for the dispatcher dark theme.
// The cabinet codebase styles heavily with inline `style={{...}}`, so we expose
// tokens as plain TS constants (used inline) AND mirror the palette into
// tailwind.config.ts under `colors.scada.*` for utility classes.

export const scada = {
  // РЕДИЗАЙН: chrome-палітра перецілена на глобальні дизайн-токени (var(--…)),
  // тож SCADA автоматично відповідає концепції й підтримує світлу/темну тему.
  // Значення вживаються ІНЛАЙН (style={{...}}), а CSS-змінні там резолвляться.
  // accent і state/quality лишаються літеральними — вони подекуди дістають
  // альфа-суфікс (`${scada.accent}1A`), а до var() альфу так не додати.
  bg: 'var(--bg)',                 // app background
  panel: 'var(--surface-solid)',   // card background (opaque — щільні дані)
  panel2: 'var(--surface-2)',      // nested / header background
  panelHover: 'var(--surface-2)',
  border: 'var(--line)',
  borderStrong: 'var(--line-strong)',

  text: 'var(--text)',             // primary text
  textDim: 'var(--text-muted)',    // secondary
  textMuted: 'var(--text-dim)',    // tertiary / labels

  accent: '#D12229',    // Helios brand red — selection / active (літерал: alpha-suffix)

  // Operational state palette (status of an asset / device)
  state: {
    ok: '#22C55E',
    warning: '#F59E0B',
    alarm: '#EF4444',
    offline: '#6B7480',
    curtailed: '#38BDF8', // active power limit / СКО
    maintenance: '#A855F7',
    commissioning: '#EAB308',
  },

  // Data-quality palette (§12 quality field)
  quality: {
    good: '#22C55E',
    stale: '#F59E0B',
    buffered: '#38BDF8',
    read_error: '#EF4444',
    invalid: '#EF4444',
    manual: '#A855F7',
    simulated: '#6B7480',
  },
} as const;

export type OpState =
  | 'ok' | 'warning' | 'alarm' | 'offline'
  | 'curtailed' | 'maintenance' | 'commissioning';

export type Quality =
  | 'good' | 'stale' | 'buffered' | 'read_error'
  | 'invalid' | 'manual' | 'simulated';

export const STATE_LABEL: Record<OpState, string> = {
  get ok() { return i18n.t('ak_scada_normal'); },
  get warning() { return i18n.t('ak_scada_warning'); },
  get alarm() { return i18n.t('ak_scada_alarm'); },
  get offline() { return i18n.t('ak_scada_no_link'); },
  get curtailed() { return i18n.t('ak_scada_curtailed'); },
  get maintenance() { return i18n.t('ak_scada_planned_maintenance'); },
  get commissioning() { return i18n.t('ak_scada_commissioning'); },
};

export const stateColor = (s: OpState): string => scada.state[s];
export const qualityColor = (q: Quality): string => scada.quality[q];
